module.exports = __webpack_public_path__ + "static/media/nsf-logo.add8a934.png";